import React from "react";
import {Modal} from "antd";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {
    ModalContainer,
    ConfirmationText,
    CancelButton,
    ConfirmButton,
    ModalStyle,
    ModalBodyStyle,
    ConfirmationButtonContainer
} from "./CourierRequestConfirmationModal.styles";

const SupportRequestConfirmationModal = ({
    visible,
    onCancel,
    onConfirm,
    requestData,
    loading = false
}) => {
    const {t} = useTranslation();

    const formatDate = date => {
        return moment(date).format("DD.MM.YYYY");
    };

    const getConfirmationText = () => {
        if (!requestData) return "";

        const startDate = formatDate(requestData.startDate);
        const endDate = formatDate(requestData.endDate);
        const courierCount = requestData.courierCount;
        const totalDays = requestData.totalDays;
        const totalHours = requestData.totalHours;

        return t("screens.customerRequests.supportConfirmationText", {
            startDate,
            endDate,
            count: courierCount,
            days: totalDays,
            hours: totalHours
        });
    };

    return (
        <Modal
            title={null}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            centered
            closable={true}
            width={400}
            style={ModalStyle}
            bodyStyle={ModalBodyStyle}
        >
            <ModalContainer>
                <ConfirmationText>{getConfirmationText()}</ConfirmationText>
                <ConfirmationButtonContainer>
                    <CancelButton onClick={onCancel} disabled={loading}>
                        {t("screens.customerRequests.no")}
                    </CancelButton>
                    <ConfirmButton onClick={onConfirm} disabled={loading}>
                        {loading
                            ? t("screens.customerRequests.loading")
                            : t("screens.customerRequests.yes")}
                    </ConfirmButton>
                </ConfirmationButtonContainer>
            </ModalContainer>
        </Modal>
    );
};

export default SupportRequestConfirmationModal;
